import React from 'react';
import { peopleNeeds, purposeUses } from '../data/content';
import { SunRays } from './decor/SunRays';
export function Purpose() {
  return <section aria-labelledby="purpose-title" className="relative overflow-hidden bg-cream-deep" data-id="element-265" data-mp="2ova1s5lx638k">
      <SunRays className="pointer-events-none absolute -left-48 -bottom-48 w-[520px] text-gold/20" data-id="element-266" data-mp="33jo2a9vv5fly" />
      <div className="relative mx-auto max-w-3xl px-5 py-20 text-center sm:px-8 lg:py-28" data-id="element-267" data-mp="2yqbq4z8df1a3">
        <h2 id="purpose-title" className="text-balance font-display text-[38px] leading-[1.05] text-navy sm:text-5xl" data-id="element-268" data-mp="3chgjxkp24zci">
          Bien plus qu’une collection d’imprimables
        </h2>
        <p className="mt-6 text-lg leading-relaxed text-ink-soft" data-id="element-269" data-mp="3mfwb1no348m0">
          Il est facile de télécharger une ressource chrétienne de plus et de l’oublier sur son ordinateur. Ce pack n’a pas été créé pour cela.
        </p>
        <p className="mt-8 font-display text-3xl text-coral sm:text-4xl" data-id="element-270" data-mp="1s3g6qseun4js">Il a été créé pour être utilisé.</p>
        <ul className="mt-4 space-y-1" data-id="element-271" data-mp="1n67pqv5ft6k4">
          {purposeUses.map(u => <li key={u} className="font-display text-2xl text-navy sm:text-[28px]" data-id="element-272" data-mp="agr0u92355mi">
              {u}
            </li>)}
        </ul>
        <p className="mt-8 text-lg leading-relaxed text-ink-soft" data-id="element-273" data-mp="jfvtwzuvo6ra">Pour transformer des moments ordinaires en occasions d’orienter quelqu’un vers Christ.</p>

        <div className="mt-12 rounded-[28px] bg-white p-8 text-left shadow-card sm:p-10" data-id="element-274" data-mp="o85hwacfmwqx">
          <p className="text-lg font-bold text-navy" data-id="element-275" data-mp="t4w0p5fmg6g1">Car il y a, en ce moment même autour de vous, des personnes qui ont peut-être désespérément besoin :</p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-276" data-mp="1344qdm3geywl">
            {peopleNeeds.map((n, i) => <li key={n} className={`rounded-xl bg-cream px-5 py-3.5 font-semibold text-navy ${i === peopleNeeds.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-277" data-mp="1756t4cwkxt3b" data-mpi={i}>
                {n}
              </li>)}
          </ul>
        </div>

        <p className="mt-12 font-display text-4xl italic text-coral sm:text-5xl" data-id="element-278" data-mp="g2bi1hz20b9n">Et si vous pouviez être celui ou celle qui lui apporte ce message{'\u00A0'}?</p>
      </div>
    </section>;
}